module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ded"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('p', {
    staticClass: "ded-1"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("For my daughters Hannah and Rhiannon; with happy memories of them being small enough to wear these, and for their ongoing interest and support.")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "src": "images/ded-1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-507d38b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/03_Dedication.vue
// module id = 66
// module chunks = 0